import join from 'lodash-es/join';
import map from 'lodash-es/map';
import shoppableImage from '../helpers/ShoppableImage';

let module_name = '';
const getImages = (images) => {
  return join(
    map(images, (image) => {
      const caption = image.caption ? `<div class="Module-${module_name}__image-caption">${image.caption}</div>` : '';
      return `
    <div class="Module-${module_name}__image" data-cms-image-slider-slide>
      ${shoppableImage(image)}
      ${caption}
    </div>`;
    }),
    '',
  );
};

export default (settings, name) => {
  module_name = name;

  const images = getImages(settings.images);
  const html = `
  <div class="Module-${module_name}__Content">
    <div class="Module-${module_name}__Images" data-cms-image-slider>
      ${images}
    </div>
  </div>
  `;
  return html;
};
